import { Col, Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import { BadgesContextualTitle, BadgesOutlineContextualVariationsTitle, BadgeTagwithIconsTitle, NumberOfBadge, NumberOfPills, PillsContextualTitle, PillsOutlineTitle, RoundedPillswithIconsTitle, TagPills, UIKits } from "../../../Constants/Constants";
import CommonBadges from "./CommonBadges/CommonBadges";
import { BadgeIconData, BadgesContextualSubTitle, BadgesData, NumberBadgeIconSubTitle, NumberBadgeSubTitle, NumberPillsIconSubTitle, NumberPillsSubTitle, OutlineBadgesData, PillsContextualSubTitle } from "../../../Data/UiKits/Tag&Pills";
import BadgeHeading from "./BadgeHeading";
import PositionedBadges from "./PositionedBadges";
import { Fragment } from "react/jsx-runtime";
import ButtonBadges from "./ButtonBadges";
import ImageBadges from "./ImageBadges";
import CloseBadges from "./CloseBadges";
import ImageWithCloseBadges from "./ImageWithCloseBadges";

const TagAndPillsContainer = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle={TagPills} parent={UIKits} />
      <Container fluid>
        <Row>
          <CommonBadges title={BadgesContextualTitle} span={BadgesContextualSubTitle} data={BadgesData} />
          <CommonBadges title={BadgesOutlineContextualVariationsTitle} span={BadgesContextualSubTitle} data={OutlineBadgesData} />
          <CommonBadges title={PillsContextualTitle} span={PillsContextualSubTitle} data={BadgesData} roundedPills />
          <CommonBadges title={PillsOutlineTitle} span={PillsContextualSubTitle} data={OutlineBadgesData} roundedPills />
          <CommonBadges title={NumberOfBadge} span={NumberBadgeSubTitle} data={BadgesData} number />
          <CommonBadges title={NumberOfPills} span={NumberPillsSubTitle} data={BadgesData} number className="rounded-circle badge-p-space" />
          <CommonBadges title={BadgeTagwithIconsTitle} span={NumberBadgeIconSubTitle} data={BadgeIconData} icon />
          <CommonBadges title={RoundedPillswithIconsTitle} span={NumberPillsIconSubTitle} data={BadgeIconData} icon className="rounded-circle p-2" />
          <BadgeHeading />
          <Col sm="12" xl="6" className="box-col-12">
            <Row>
              <PositionedBadges />
              <ButtonBadges />
            </Row>
          </Col>
          <ImageBadges />
          <CloseBadges />
          <ImageWithCloseBadges />
        </Row>
      </Container>
    </Fragment>
  );
};
export default TagAndPillsContainer;
